import { ChangeDetectorRef, Component, EventEmitter, inject, Input, Output, ViewChild } from '@angular/core';
import { MatFormField, MatSelect } from '@angular/material/select';
import moment from 'moment';

import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
@AutoUnsubscribe()
@Component({
  selector: 'app-shared-dropdown',
  templateUrl: './shared-dropdown.component.html',
})
export class SharedDropdownComponent {
  @ViewChild('myFormField') myFormField: MatFormField;
  @ViewChild('mySelect') mySelect: MatSelect;

  private cd = inject(ChangeDetectorRef);
  @Input() title = '';
  @Input() list = [];
  @Input() itemType;
  @Input() itemsLength = 0;
  @Input() useName = false;
  @Input() useType = false;

  @Input() filter;
  @Input() isTwoWay = false;
  @Input() filterType = '';
  @Input() isCustomKey = false;
  @Input() lableKey = '';
  @Input() valueKey = '';
  @Input() nonVaultClassName = '';
  @Input() isMultiSelect = true;
  @Input() shouldShowChips = true;
  @Output() handleFilterChangeEmitter: EventEmitter<any> = new EventEmitter();
  @Output() handleSecondFilterChangeEmitter: EventEmitter<any> = new EventEmitter();

  @Output() handleSelectChangeEmitter: EventEmitter<any> = new EventEmitter();

  @Output() handleReactiveChangeEmitter: EventEmitter<any> = new EventEmitter();

  @Input() hasClass = false;
  @Input() isObject = true;

  @Input() isReactiveFormType = false;
  @Input() useNickName = false;

  @Output() handleFilterListEmitter: EventEmitter<any> = new EventEmitter();
  moment = moment;
  panelOpen: boolean = false;
  // Search functionality
  searchText = '';

  // Getter for filtered list based on search
  get filteredList() {
    if (!this.searchText || this.searchText.trim() === '') {
      return this.list;
    }

    const searchTerm = this.searchText.toLowerCase().trim();

    if (this.isCustomKey) {
      return this.list.filter((item) => item[this.lableKey]?.toLowerCase().includes(searchTerm));
    } else if (this.isTwoWay) {
      return this.list.filter((item) => item.type?.toLowerCase().includes(searchTerm));
    } else {
      return this.list.filter((item) => {
        const displayValue = !this.isObject ? item : this.useName ? item?.name : this.useNickName ? item?.nick_name : item?.type;
        return displayValue?.toLowerCase().includes(searchTerm);
      });
    }
  }

  // Handle search input
  onSearchInput(event: any) {
    this.searchText = event.target.value;
    this.cd.detectChanges();
  }

  // Clear all selections
  clearAllSelections() {
    if (this.isMultiSelect) {
      this.itemType = [];
    } else {
      this.itemType = null;
    }
    this.searchText = '';
    this.cd.detectChanges();

    // Emit the change
    if (this.isCustomKey) {
      this.handleSelectChangeEmitter.emit({ value: this.itemType });
    } else if (this.isTwoWay) {
      this.handleSecondFilterChange();
    } else {
      this.handleSecondFilterChange({ value: this.itemType });
    }
  }

  handleFilterChange(val: any) {
    this.handleFilterChangeEmitter.emit(val);
    this.handleFilterListEmitter.emit(this.itemType);
  }

  handleSelectChange(val: any) {
    this.handleSelectChangeEmitter.emit(val.value);
  }

  handleSecondFilterChange(val?: any) {
    if (!val && this.isTwoWay) {
      this.filter[this.filterType] = this.itemType;
      this.handleSecondFilterChangeEmitter.emit(this.filter);
    } else if (!this.isObject && this.isReactiveFormType) {
      this.handleReactiveChangeEmitter.emit(val.value);
    }
  }
}
